import { FileSpreadsheet, FileDown, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { API, WA_LINK } from "@/lib/api";

const COLUMNS = ["Nama", "Tanggal Lahir", "No Passport", "No Visa"];

const PREVIEW_ROWS = [
  ["MUHAMMAD AHMAD", "01/01/1990", "A1234567", "V987654321"],
  ["SITI FATIMAH", "14/05/1985", "B7654321", "V123450987"],
  ["ABDULLAH RAHMAN", "23/09/1978", "C9871234", "V456781234"],
];

export const TemplateSection = () => (
  <section id="template" className="relative py-20 lg:py-28 overflow-hidden" data-testid="template-section">
    <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full bg-sky-700/10 blur-[160px]" aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <div className="grid lg:grid-cols-12 gap-12 items-center">
        <Reveal className="lg:col-span-5">
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-sky-400">Template Data Jamaah</p>
          <h2 className="mt-4 font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-white" data-testid="template-title">
            Download Template Excel, Isi, Kirim — Selesai
          </h2>
          <p className="mt-4 text-base text-slate-400 leading-relaxed">
            Gunakan format standar kami untuk booking permit massal. Cukup 4 kolom wajib untuk setiap jamaah:
          </p>
          <div className="mt-5 flex flex-wrap gap-2" data-testid="template-columns">
            {COLUMNS.map((c) => (
              <span key={c} className="text-xs font-mono2 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-400/30 text-emerald-300">
                {c}
              </span>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-4">
            <a
              href={`${API}/template.xlsx`}
              data-testid="download-xlsx-button"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-white bg-gradient-to-br from-emerald-600 to-emerald-800 hover:from-emerald-500 hover:to-emerald-700 shadow-lg shadow-emerald-950/50 transition-all duration-300 hover:-translate-y-0.5"
            >
              <FileSpreadsheet size={17} />
              Download .XLSX
            </a>
            <a
              href={`${API}/template.csv`}
              data-testid="download-csv-button"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-slate-100 border border-white/20 hover:border-sky-400/60 hover:text-sky-300 transition-colors duration-300"
            >
              <FileDown size={17} />
              Download .CSV
            </a>
          </div>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="template-whatsapp-link"
            className="mt-6 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-emerald-300 transition-colors duration-200"
          >
            <MessageCircle size={15} className="text-emerald-400" />
            Setelah diisi, kirim file langsung ke WhatsApp Admin 082393244452
          </a>
        </Reveal>

        <Reveal className="lg:col-span-7" delay={0.15}>
          <div className="glass rounded-2xl overflow-hidden shadow-2xl shadow-sky-950/40" data-testid="template-preview-table">
            <div className="flex items-center gap-2 px-5 py-3.5 border-b border-white/8">
              <span className="w-2.5 h-2.5 rounded-full bg-red-400/70" />
              <span className="w-2.5 h-2.5 rounded-full bg-amber-400/70" />
              <span className="w-2.5 h-2.5 rounded-full bg-emerald-400/70" />
              <span className="ml-3 font-mono2 text-xs text-slate-400">template-data-jamaah.xlsx</span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-[#0F172A]">
                    {COLUMNS.map((c) => (
                      <th key={c} className="text-left font-mono2 text-xs uppercase tracking-wider text-sky-300 px-5 py-3.5 whitespace-nowrap">
                        {c}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {PREVIEW_ROWS.map((row, i) => (
                    <tr key={i} className="border-t border-white/5 hover:bg-white/[0.03] transition-colors duration-200">
                      {row.map((cell, j) => (
                        <td key={j} className={`px-5 py-3.5 whitespace-nowrap ${j === 0 ? "text-slate-200" : "font-mono2 text-slate-400"}`}>
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="px-5 py-3 border-t border-white/8">
              <p className="text-xs text-slate-500">Baris pertama adalah contoh — ganti dengan data jamaah Anda.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
